export default "__VITE_ASSET__YPnxIp3S__"